export default "__VITE_ASSET__0f01430e__"